module.exports = __webpack_public_path__ + "static/media/ulip.8b5dc66c.mp3";